<template>
  <div class="entity-form tag-picker" @click.stop>
    <form @submit.prevent.stop="saveAndClose">
      <div class="form-heading">
        <button class="button-primary button-primary__thin" type="button" @click="cancelForm">{{$t('form.filter.cancel')}}</button>
        <div class="form-title">{{$t('form.filter.heading')}}</div>
        <button class="button-primary button-primary__inverse button-primary__thin" type="submit" >{{$t('form.filter.save')}}</button>
      </div>

      <div class="flex-column entity-form-content">
        <div class="tags" style="max-height: calc(100vh - 200px); overflow-y: scroll;">
          <TagToggle v-for="tag in tags" :key="`tag-${tag.id}`" :tag="tag" @change="updateTagStatus"/>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import * as types from '@/store/mutations'
import TagToggle from "@/components/forms/inputs/TagToggle.vue";
export default {
  name: 'TagPicker',
  data(){
    return {
      statuses: {
        builtin: [],
        custom: []
      }
    }
  },
  components: {
    TagToggle
  },
  beforeMount(){
    let storedActiveTags =  JSON.parse(JSON.stringify( this.$store.state.customers.filters.activeTags ))
    this.statuses.builtin = storedActiveTags.builtin
    this.statuses.custom = storedActiveTags.custom
  },
  computed: {
    tags () {
      let tags = []
      let { builtin, custom } = this.$store.getters.tags
      let activeTags = [
        ...this.statuses.custom,
        ...this.statuses.builtin
      ]

      for (let id in builtin) {
        let tag = {
          id,
          label: builtin[id],
          active: activeTags.includes(id)
        }
        tags.push(tag)
      }

      for (let id in custom) {
        id = parseInt(id)
        let tag = {
          id,
          label: custom[id],
          active: activeTags.includes(id)
        }
        tags.push(tag)
      }

      return tags
    }
  },
  methods: {
    updateTagStatus({id, to}){
      let { builtin, custom } = this.$store.getters.tags
      if(builtin[id]){
        if(to){
          this.statuses.builtin.push(id)
          return
        }
        let position = this.statuses.builtin.indexOf(id)
        if(position === -1){
          console.warn('this tag is already removed', id, typeof id, this.statuses.builtin)
          return
        }
        this.statuses.builtin.splice(position,1)
        return
      }

      if(custom[id]){
        if(to){ // enable
          this.statuses.custom.push(parseInt(id))
          return
        }
        // remove
        let position = this.statuses.custom.indexOf(id)
        if(position === -1){
          console.warn('this tag is already removed', id, typeof id, this.statuses.custom)
          return
        }
        this.statuses.custom.splice(position,1)
        return
      }

      console.warn("Can't figure out what to do with this tag:", id, typeof id, this.statuses)
    },
    cancelForm () {
      this.$store.commit(types.CLOSE_FILTERPAGE, this.statuses)
    },
    save(){
      this.$store.commit(types.UPDATE_ALL_TAGS_STATUSES, this.statuses)
    },
    saveAndClose(){
      this.save()
      this.$store.commit(types.CLOSE_FILTERPAGE, this.statuses)
    }
  }
}
</script>

<style lang="css" scoped>
.tags {
  flex-wrap: wrap;
  margin-left: -8px;
  margin-right: -8px;
}
.tags > * {
  margin: 8px;
}
</style>
